import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	templateUrl: './set_uber_tariff.component.html'
})
export class SetUberTariffModalComponent extends BaseSupportModalComponent {
	userId: string;
	siteId: string;
	time: string = '';
	uberStartDate: string = '';

	async ok() {
		await this.supportService.uberTariff(this.userId, this.uberStartDate, this.userId, this.time, this.spreader.base.comment).toPromise();

		this.execute();
	}
}
